import { SET_PAGE_META, SET_NO_PERMISSION } from './types';

export const setPageMeta = (payload) => {
  return { type: SET_PAGE_META, payload };
};

export const setNoPermission = (payload) => {
  return { type: SET_NO_PERMISSION, payload };
};
